
const  AppConfig = window.configsMain;

export default AppConfig;
